import { RadioGroup } from '@madpaws/design-system';
import { useField } from 'formik';

import type { RadioGroupOnChange } from '@madpaws/design-system';
// TODO (WEB-81) fix import when prop types will be exported
import type { Props as RadioProps } from '@madpaws/design-system/dist/components/RadioGroup/RadioGroup';
import type { ReactElement } from 'react';

type Props = Omit<RadioProps, 'onChange' | 'value'>;

const RadioGroupField = ({ name, options, ...rest }: Props): ReactElement => {
  const [{ value }, {}, { setValue }] = useField(name);

  const onChange = ({ target }: RadioGroupOnChange): void => {
    setValue(target.value.value);
  };

  return (
    <RadioGroup name={name} onChange={onChange} options={options} value={{ value }} {...rest} />
  );
};

export { RadioGroupField };
